import React from 'react'
import API from '../../services/api.jsx'
import Loader from '../layout/loader.jsx'
import Head from '../layout/head.jsx'
import Content from '../layout/content.jsx'
import Table from '../layout/table.jsx'

class NewsList extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            loading: true,
            filters: {},
            newsList: {
                columns: [
                    {
                        label: 'News name in English',
                        key: 'nameEn'
                    },
                    {
                        label: 'News name in Chinese',
                        key: 'nameZh'
                    },
                    {
                        content: 'Edit',
                        action: 'edit',
                        className: 'edit-link',
                        onClick: (id, key) => {
                            this.props.history.push('/news/' + id + '/edit')
                        }
                    }],
                entities: [],
                filters: [],
                actions: [{
                    classList: 'blue add',
                    label: 'New news',
                    onClick: () => this.props.history.push('/news/new')
                }],
                selectedItems: [],
                multiSelect: false,
            }
        }
    }

    componentDidMount() {
        API.getNewsList(this.state.filters).then(entities => {
            entities.forEach(entity => {
                if (entity.name) {
                    if (entity.name.en) {
                        entity.nameEn = entity.name.en
                    } else {
                        entity.nameEn = '-'
                    }

                    if (entity.name.zh) {
                        entity.nameZh = entity.name.zh
                    } else {
                        entity.nameZh = '-'
                    }
                }
            })

            this.setState({
                ...this.state,
                loading: false,
                newsList: {...this.state.newsList, entities: entities}
            })
        })
    }

    loadEntities() {
        API.getNewsList(this.state.filters).then(entities => {
            entities.forEach(entity => {
                if (entity.name) {
                    if (entity.name.en) {
                        entity.nameEn = entity.name.en
                    } else {
                        entity.nameEn = '-'
                    }

                    if (entity.name.zh) {
                        entity.nameZh = entity.name.zh
                    } else {
                        entity.nameZh = '-'
                    }
                }
            })

            this.setState({
                ...this.state,
                loading: false,
                newsList: {...this.state.newsList, entities: entities}
            })
        })
    }

    render() {
        if (this.state.loading)
            return <Loader/>
        else
            return <>
                <Head title={'News'}/>
                <Content>
                    <Table settings={this.state.newsList}/>
                </Content>
            </>
    }
}

export default NewsList
